import React, { useState } from 'react';
import { PushComponent, UiComponent } from 'components';
import { useIsMobile, usePageOption } from 'hooks';
import { PushQuery } from 'queries';
import { SearchPushFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption(10);
  const [filter, setFilter] = useState<SearchPushFilterType>({});
  const { data } = PushQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <PushComponent.List
      {...pageState}
      toolbar={<PushComponent.Filter handleFilter={setFilter} />}
      totalPage={data?.totalPages}
      data={data?.data || []}
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  const title = <UiComponent.PageTitle>앱 푸시 관리</UiComponent.PageTitle>;

  if (isMobile) return <PushComponent.MobileList title={title} />;

  return (
    <>
      {title}
      <DesktopList />
    </>
  );
}

export default List;
